import { render } from "./_Modal.vue?vue&type=template&id=edb41126&scoped=true"
import script from "./_Modal.vue?vue&type=script&lang=js"
export * from "./_Modal.vue?vue&type=script&lang=js"

import "./_Modal.vue?vue&type=style&index=0&id=edb41126&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-edb41126"

export default script